import React from 'react'
import styled from 'styled-components'

const SelectContainer = styled.div`
  position: relative;
  display: inline-block;
  width: 100%;
`

const SelectElement = styled.select`
  width: ${(props) => props.width || '100%'};
  padding: 0 0.5rem;
  font-size: 0.8rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-color: white;
  background-image: url('data:image/svg+xml;charset=US-ASCII,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 4 5"><path fill="%23999" d="M2 0L0 2h4zm0 5L0 3h4z"/></svg>');
  background-repeat: no-repeat;
  background-position: right 10px top 50%;
  background-size: 10px 10px;

  &:focus {
    outline: none;
    border-color: #2e8ab8 !important;
    box-shadow: 0px 0px 2px rgba(46, 138, 184, 0.75) !important;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
    background-color: #f8f8f8;
    color: #bbbbbd;
  }
`

export const SelectOption = styled.option``

const Select = React.forwardRef(({ ...props }, ref) => (
  <SelectContainer>
    <SelectElement innerRef={ref} {...props} />
  </SelectContainer>
))

export default Select
